import React from "react";

import styles from "./styles/VerifyAccountPage.scss";
import { navigateTo404Page } from "../../history";

const verifiedCode = {
  verified: "200",
  expired: "400",
  deleted: "404"
};

const renderMessage = (code: string) => {
  switch (code) {
    case verifiedCode.verified:
      return "Vaša e-mail adresa je potvrđena";

    case verifiedCode.expired:
      return "Ova veza je istekla";

    case verifiedCode.deleted:
      return "Račun je obrisan";

    default:
      return "";
  }
};

function VerifyAccountPage({
  match: {
    params: { code }
  }
}) {
  if (!Object.values(verifiedCode).includes(code)) {
    navigateTo404Page();
  }

  return (
    <div className={`child-center ${styles.text}`}>{renderMessage(code)}</div>
  );
}

export default VerifyAccountPage;



// WEBPACK FOOTER //
// ./src/containers/VerifyAccountPage/index.tsx